/* 
    ruleKey: {
        required // 是否必填
        length // 长度校验
        pattern // 校验正则
        message //校验文案提示
    }
 */
export default {
  required: {
    required: true,
  },
  length20: {
    length: 20,
  },
  length100: {
    length: 100,
  },
  name: {
    required: true,
    length: 20,
  },
  adminUserName: {
    required: true,
    length: 10,
  },
  idNumber: {
    required: true,
    pattern:
      /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/,
    message: "请输入正确格式的身份证号",
  },
  CN: {
    required: true,
    pattern: "^[a-zA-Z\\d/-]{1,20}$",
    message: "由数字、字母、“-”、“/”组成",
    length: 20,
  },
  codeDomestic: {
    pattern: "^[\\d-]{1,10}$",
    message: "由数字、“-”组成",
    length: 10,
  },
  email: {
    pattern: "^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$",
    message: "请输入正确E-mail",
  },
  website: {
    pattern:
      /^(https?:\/\/)?([\da-z\.-]+)\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2})(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/,
    message: "请输入正确网站地址",
  },
};
